import Swal from "sweetalert2";
import { clearMemory, processRequest, setError, setServicesFrecuency, setServicesMaxMin } from "./slice";
import { URL_API } from "../../../../app/apiConnection";



export const clearStoreNewReports = () => {
    return (dispatch, getState) => {
        dispatch(clearMemory());
    }
}



export const getServicesMaxMin = (dateBegin, dateEnd, period, opcion, limit) => {
    return async (dispatch, getState) => {
        dispatch(clearMemory());
        dispatch(processRequest());
        // ultimo parametro limit

        await URL_API.get(`/Reportes/getReportServicesForPeriod/${dateBegin}/${dateEnd}/${period}/${opcion}/${limit}`).then(function (response) {
            // console.log(response.data);
            if (response.data.status == 200) {
                dispatch(setServicesMaxMin({
                    msg: response.data.msg,
                    dateStart: response.data.fFinal,
                    dateEnd: response.data.fInicio,
                    servicesMaxMin: response.data.data
                }))
            }

            if (response.data.success == false) {
                Swal.fire({
                    icon: "warning",
                    title: "Atencion...",
                    text: response.data.msg,
                    customClass: {
                        confirmButton: 'btn btn-primary',  // rojo
                        cancelButton: 'btn btn-secondary' // gris
                    },
                });
            }

        }).catch(function (error) {
            console.log(error.response.data);

             Swal.fire({
                    icon: "warning",
                    title: "Atencion...",
                    text: error.response.data.msg,
                    customClass: {
                        confirmButton: 'btn btn-primary',  // rojo
                        cancelButton: 'btn btn-secondary' // gris
                    },
                });


            dispatch(setError({
                msg: error.response.data.msg

            }))
        });
    }
}

export const getServicesFrecuency = (dateBegin, dateEnd, opcion, limit) => {
    return async (dispatch, getState) => {
        dispatch(clearMemory());
        dispatch(processRequest());
        // ultimo parametro limit
        
        await URL_API.get(`/Reportes/getReportServicesForFrecuency/${dateBegin}/${dateEnd}/${opcion}/${limit}`).then(function (response) {
            // console.log(response.data);
            if (response.data.status == 200) {
                dispatch(setServicesFrecuency({
                    msg: response.data.msg,
                    dateStart: response.data.fFinal,
                    dateEnd: response.data.fInicio,
                    frecuency: response.data.data
                }))
            }

            if (response.data.success == false) {
                Swal.fire({
                    icon: "warning",
                    title: "Atencion...",
                    text: response.data.msg,
                    customClass: {
                        confirmButton: 'btn btn-primary',  // rojo
                        cancelButton: 'btn btn-secondary' // gris
                    },
                });
            }

        }).catch(function (error) {
            console.log(error.response.data);

             Swal.fire({
                    icon: "warning",
                    title: "Atencion...",
                    text: error.response.data.msg,
                    customClass: {
                        confirmButton: 'btn btn-primary',  // rojo
                        cancelButton: 'btn btn-secondary' // gris
                    },
                });


            dispatch(setError({
                msg: error.response.data.msg

            }))
        });
    }
}

